import { layouts } from "./availableLayouts";

export const updateLayout = (layout, cardDesign = null, setCardDesign) => {
  const valid_layout = layouts.filter((l) => l.id === layout);
  if (valid_layout.length === 1) setCardDesign(layout);
};
